import { render, staticRenderFns } from "./ChartYears.vue?vue&type=template&id=68542f2c&"
import script from "./ChartYears.vue?vue&type=script&lang=js&"
export * from "./ChartYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports